module.exports = __webpack_public_path__ + "media/images/chat_message_icon-969f230c4c2389aa535093acab3706a9.png";